const {hostname} = window.location;

interface EnvConfig {
    directoryApiBaseUrl: string;
    productApiBaseUrl: string;
    pingLoginUrl: string;
    pingAuthBaseUrl: string;
    pingApplicationId: string;
    pingCallbackDomain: string;
    pendoIdPrefix: string;
    msoDashboardUrl: string;
}

const storeTreezApiUrlBase = 'https://store.treez.io';
const tokenCookieKey = 'TREEZ_TOKEN';
const subdomain = hostname?.split('.')?.[0];
const env = subdomain?.split('-')?.[1] || ''; // e.g. 'ci' or 'qa'

// Default config (if not matched in switch case below), e.g. for CI and QA environments:
let config: EnvConfig = {
    directoryApiBaseUrl: `https://directory-${env}-ping.api.build.treez.io/v2`,
    productApiBaseUrl: `https://product-${env}-ping.api.build.treez.io/v3`,
    pingLoginUrl: 'https://login.dev.treez.io',
    pingAuthBaseUrl: 'https://api.dev.treez.io/auth/v1',
    pingApplicationId: 'BrandAndEpm',
    pingCallbackDomain: hostname,
    pendoIdPrefix: `${env}-`,
    msoDashboardUrl: 'https://app.dev.treez.io',
};

switch (hostname) {
    case 'localhost': // Local development
        config = {
            directoryApiBaseUrl: 'http://localhost:5100/v2',
            productApiBaseUrl: 'http://localhost:8303/v3',
            pingLoginUrl: 'https://login.dev.treez.io',
            pingAuthBaseUrl: 'https://api.dev.treez.io/auth/v1',
            pingApplicationId: 'BrandAndEpm',
            pingCallbackDomain: `${hostname}:9008`,
            pendoIdPrefix: 'dev-',
            msoDashboardUrl: 'https://app.dev.treez.io',
        };
        // DEV TESTING: Use the existing platform services in CI:
        config.directoryApiBaseUrl = `https://directory-ci-ping.api.build.treez.io/v2`;
        config.productApiBaseUrl = `https://product-ci-ping.api.build.treez.io/v3`;
        break;
    case 'plan-ci.treez.io':
    case 'plan-ci-ping.treez.io':
    case 'plan-ci-ping.build.treez.io':
        // CI: Use the initial values set above
        break;
    case 'plan-qa.treez.io':
    case 'plan-qa-ping.treez.io':
    case 'plan-qa-ping.build.treez.io':
        config.directoryApiBaseUrl = `https://directory-qa-ping.api.build.treez.io/v2`;
        config.productApiBaseUrl = `https://product-qa-ping.api.build.treez.io/v3`;
        // QA: Use the initial values set above
        break;
    case 'plan-stg.treez.io': // Staging
        config = {
            directoryApiBaseUrl: 'https://directory-stg.api.prod.treez.io/v2',
            productApiBaseUrl: 'https://product-stg.api.prod.treez.io/v3',
            pingLoginUrl: 'https://login.treez.io',
            pingAuthBaseUrl: 'https://api.treez.io/auth/v1',
            pingApplicationId: 'BrandAndEpm',
            pingCallbackDomain: hostname,
            pendoIdPrefix: '',
            msoDashboardUrl: 'https://app.dev.treez.io',
        };
        break;
    case 'plan-prod-ping.prod.treez.io': // pre-Production
    case 'plan.treez.io': // Production
        config = {
            directoryApiBaseUrl: 'https://directory-prod-ping.api.prod.treez.io/v2',
            productApiBaseUrl: 'https://product-prod-ping.api.prod.treez.io/v3',
            pingLoginUrl: 'https://login.treez.io',
            pingAuthBaseUrl: 'https://api.treez.io/auth/v1',
            pingApplicationId: 'BrandAndEpm',
            pingCallbackDomain: hostname,
            pendoIdPrefix: '',
            msoDashboardUrl: 'https://app.treez.io',
        };
        break;
    default:
        // Using the initial values set above
        break;
}

export const MSO_DASHBOARD_URL = config.msoDashboardUrl;
export const DIRECTORY_API_URL = config.directoryApiBaseUrl;
export const PRODUCT_API_URL = config.productApiBaseUrl;
export const STORE_TREEZ_API_URL = storeTreezApiUrlBase;

export const PING_AUTH_BASE_URL = config.pingAuthBaseUrl;
export const TOKEN_COOKIE_KEY = tokenCookieKey;

export const PING_LOGIN_URL = config.pingLoginUrl;
export const PING_APPLICATION_ID = config.pingApplicationId;
export const PING_CALLBACK_DOMAIN = config.pingCallbackDomain;

export const PENDO_ID_PREFIX = config.pendoIdPrefix;
export const PENDO_TREEZ_API_KEY = '717f8af9-6f01-42a1-73f2-c643a5927d2e';

// These values should be auto-updated as part of the build process:
// FIXME: These updates should be made with build artifacts and not constantly update this source file
export const APP_VERSION = 'v2.1.7';
export const APP_COMMIT = '';
export const APP_DATESTAMP = '2024-03-20.15:19:47';
